class EeveePageController{
    constructor(){
        
    }
}
module.exports=EeveePageController
